import { jsx as o } from "react/jsx-runtime";
import { V as e } from "../../vendor--aJiswR_.js";
import "react";
import "../../theme/spacing.js";
import { omitStyleRenderProps as t } from "../../utils/omitStyleRenderProps/index.js";
import '../../assets/index46.css';const f = "_fieldError_9fqgm_1", i = {
  fieldError: f
};
function l(r) {
  return /* @__PURE__ */ o(
    e,
    {
      ...t(r),
      className: i.fieldError,
      "data-component": "FieldError"
    }
  );
}
export {
  l as FieldError
};
//# sourceMappingURL=index.js.map
